import { DEFAULT_PADDING_LR, DEFAULT_TAIL_WHITESPACE_CALCULATION, FONT_SCALE } from '../constants';
import { DocumentElement, measureText, WhiteSpaceType, DocSizeType } from '@tencent/alloy-editor';
/**
 * 文本测量相关逻辑
 */
export default class ParagraphMeasure {
    private static paddingOffsetMap = new Map();

    /**
     * 探测内容显示的宽度能否放到Editor容器中，如果可以缩减Editor的Padding值
     * @param key
     * @param documentElement
     * @param editorWidth
     * @param editorPaddingLeft
     * @param editorPaddingRight
     * @returns {*}
     */
    public static computePaddingOffset(
        key: string,
        documentElement: DocumentElement,
        editorWidth: number,
        editorPaddingLeft: number,
        editorPaddingRight: number,
    ): { offsetPaddingLeft: number, offsetPaddingRight: number } {
        const defaultOffset = { offsetPaddingLeft: 0, offsetPaddingRight: 0 };
        if (!documentElement || !editorWidth) return defaultOffset;

        // 取缓存
        const paddingOffsetObj = this.paddingOffsetMap.get(key);
        if (!(typeof (paddingOffsetObj) === 'undefined')) {
            return paddingOffsetObj;
        }
        // 改为不换行模式
        const docElement = { ...documentElement, whiteSpaceType: WhiteSpaceType.NowrapExceptForceBreak, paddingLeft: 0,
            paddingRight: 0, paddingTop: 0, paddingBottom: 0, docSizeType: DocSizeType.WrapContent,
            tailWhitespaceCalculation: DEFAULT_TAIL_WHITESPACE_CALCULATION };
        const { width: paraWidth } = measureText(docElement, editorWidth);

        if (paraWidth >= 0) {
            const trueWidth = editorWidth - editorPaddingLeft - editorPaddingRight;
            if (paraWidth >= trueWidth && paraWidth <= editorWidth) {
                let offsetLeft = 0;
                let offsetRight = 0;
                if (paraWidth - trueWidth <= editorPaddingRight) {
                    offsetRight = paraWidth - trueWidth;
                } else if (paraWidth - trueWidth <= (editorPaddingLeft + editorPaddingRight)) {
                    offsetRight = editorPaddingRight;
                    offsetLeft = paraWidth - trueWidth - editorPaddingRight;
                }
                const returnValue = {
                    offsetPaddingLeft: Math.ceil(offsetLeft),
                    offsetPaddingRight: Math.ceil(offsetRight),
                };
                if (returnValue.offsetPaddingLeft + returnValue.offsetPaddingRight
                    <= DEFAULT_PADDING_LR * FONT_SCALE * 2) {
                    this.paddingOffsetMap.set(key, returnValue);
                    return returnValue;
                }
            }
        }
        this.paddingOffsetMap.set(key, defaultOffset);
        return defaultOffset;
    }

    public static getPaddingOffset(key: string): { offsetPaddingLeft: number, offsetPaddingRight: number } | undefined {
        // 取缓存
        const paddingOffsetObj = this.paddingOffsetMap.get(key);
        if (!(typeof (paddingOffsetObj) === 'undefined')) {
            return paddingOffsetObj;
        }
    }

    public static setDefaultPaddingOffset(key: string) {
        if (!key) return;
        const defaultOffset = { offsetPaddingLeft: 0, offsetPaddingRight: 0 };
        this.paddingOffsetMap.set(key, defaultOffset);
    }
}
